<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getFollowUpDetails)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getFollowUpDetails)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getFollowUpDetails, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getFollowUpDetails, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/examDetail', '随访明细统计')"
          icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 随访明细列表 -->
      <el-table v-loading="loading" :data="followUpDetailsList" :max-height="tableHeight" border>
        <el-table-column label="医馆名称" prop="deptName" fixed/>
        <el-table-column label="患者姓名" prop="patientName" fixed/>
        <el-table-column label="患者电话" prop="phone" min-width="100"/>
        <el-table-column label="就诊时间" prop="schedulingTime" min-width="140"/>
        <el-table-column label="医生姓名" prop="doctorName"/>
        <el-table-column label="医生诊断" prop="diagnosis" min-width="140"/>
        <el-table-column label="预计随访人员" prop="examPlanName" min-width="110"/>
        <el-table-column label="实际随访人员" prop="examRealityName" min-width="110"/>
        <el-table-column label="随访状态" prop="status"/>
        <el-table-column label="随访类型" prop="type"/>
        <el-table-column label="随访途径" prop="channel"/>
        <el-table-column label="复诊时间" prop="visitTime" min-width="140"/>
        <el-table-column label="满意程度" prop="level"/>
        <el-table-column label="疗效反馈" prop="effectFeedback"/>
        <el-table-column label="预约挂号" prop="isRegister"/>
        <el-table-column label="其他信息" prop="describe" min-width="140"/>
        <el-table-column label="计划随访时间" prop="examTime" min-width="140"/>
        <el-table-column label="随访完成时间" prop="completeTime" min-width="140"/>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getFollowUpDetails)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { followUpDetailsStatistics } from "@/api/statement"; // 报表统计请求
export default {
  name: 'FollowupDetails',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      followUpDetailsList: [], // 随访明细统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getFollowUpDetails);
  },
  methods: {
    // 请求所有随访明细统计列表
    async getFollowUpDetails() {
      let { rows, code, total } = await followUpDetailsStatistics(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.followUpDetailsList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>